// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1MwMc","boxTitle":"Qualiphy_boxTitle__3Ghvx","box":"Qualiphy_box__1oCzZ","toggleWrap":"Qualiphy_toggleWrap__wRzQb"};